import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CourseOfferingLandingPageOverview } from '../models/course-offering-landing-page-overview.model';

@Injectable()
export class CourseOfferingLandingPageService {
    private _overview$ = new BehaviorSubject<CourseOfferingLandingPageOverview | null>(null);

    setOverview(overview: CourseOfferingLandingPageOverview): void {
        this._overview$.next(overview);
    }

    get overview$() {
        return this._overview$.asObservable();
    }

    get overview(): CourseOfferingLandingPageOverview | null {
        return this._overview$.value;
    }
}
